module.exports = __webpack_public_path__ + "img/40.needs_improvement.6751ffbd.svg";